import BaseApiService from "./base-services/baseApi.service";

class FacilitiesApiService extends BaseApiService {
	constructor() {
		super();
	}

	facilitiesList = async () => {
		const url = `/website/facilities/facility-list`;
		const res = await this.axiosInstance.get(url);
		return await res.data;
	};

	getFacilitiesDetails = async (slug) => {
		const url = `/website/facilities/facility-detail?slug=${slug}`;
		const res = await this.axiosInstance.get(url);
		return await res.data;
	};
}
const facilitiesApiService = new FacilitiesApiService();
export { facilitiesApiService };
